import {DEFAULT_SEND_MESSAGE_PLACEHOLDER} from '@/components/ChatSection/consts'
import type {Thread} from '@/models/threadModel'

export const isGeneratingAtom = atom(false)
export const activeThreadIdAtom = atom<Thread['id'] | undefined>(undefined)
export const messageInputAtom = atom('')
export const messageInputPlaceholderAtom = atom(DEFAULT_SEND_MESSAGE_PLACEHOLDER)
export const messageInputIsDisabledAtom = atom(false)
export const latestPromptsAtom = atom<string[]>([])
